var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.14062V6.875C24 5.42525 22.8248 4.25 21.375 4.25H2.625C1.17525 4.25 0 5.42525 0 6.875V8.14062C0 8.27005 0.104953 8.375 0.234375 8.375H23.7656C23.895 8.375 24 8.27005 24 8.14062Z",
    fill: "#579FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1094V18.125C0 19.5747 1.17525 20.75 2.625 20.75H21.375C22.8248 20.75 24 19.5747 24 18.125V10.1094C24 9.97995 23.895 9.875 23.7656 9.875H0.234375C0.104953 9.875 0 9.97995 0 10.1094ZM6 16.25C6 16.6642 5.66419 17 5.25 17H4.5C4.08581 17 3.75 16.6642 3.75 16.25V15.5C3.75 15.0858 4.08581 14.75 4.5 14.75H5.25C5.66419 14.75 6 15.0858 6 15.5V16.25Z",
    fill: "#579FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardTransfer);
export default __webpack_public_path__ + "static/media/icon-card-transfer.b5a86dac9f971003541c8009d884d9d0.svg";
export { ForwardRef as ReactComponent };